import React from "react";
import slugs from "../../resources/slugs";
import { 
  EditOutlined, 
  SettingOutlined, 
  PictureOutlined, 
  QuestionCircleOutlined, 
  TeamOutlined, 
  HomeOutlined,
  RocketOutlined,
  FileTextOutlined,
  CustomerServiceOutlined,
  AppstoreOutlined,
  DatabaseOutlined
} from "@ant-design/icons";

export default function getMenuData() {
  return [
    {
      title: "Dashboard",
      key: "dashboards",
      icon: React.createElement(AppstoreOutlined),
      url: slugs.dashboard,
    },
    {
      title: "SITE CONTENT",
      key: "site_content",
      type: 'group',
      children: [
        {
          title: "Home Hero",
          key: "home_page_cms",
          url: slugs.cms_home,
          icon: React.createElement(HomeOutlined),
        },
        {
          title: "Banking Modules",
          key: "banking_cms",
          url: slugs.cms_banking,
          icon: React.createElement(DatabaseOutlined),
        },
        {
          title: "Blog Engine",
          key: "blogs_cms",
          url: slugs.cms_blogs,
          icon: React.createElement(FileTextOutlined),
        },
        {
          title: "Ecosystem",
          key: "ecosystem_cms",
          url: slugs.cms_ecosystem,
          icon: React.createElement(RocketOutlined),
        },
        {
          title: "How It Works",
          key: "how_it_works_cms",
          url: slugs.cms_how_it_works,
          icon: React.createElement(SettingOutlined),
        },
      ]
    },
    {
      title: "RESOURCES",
      key: "resources_group",
      type: 'group',
      children: [
        {
          title: "FAQ Center",
          key: "faq_cms",
          url: slugs.cms_faqs,
          icon: React.createElement(QuestionCircleOutlined),
        },
        {
          title: "Trust & Reviews",
          key: "testimonials_cms",
          url: slugs.cms_testimonials,
          icon: React.createElement(CustomerServiceOutlined),
        },
        {
          title: "Partners",
          key: "partners_cms",
          url: slugs.cms_partners,
          icon: React.createElement(TeamOutlined),
        },
        {
          title: "About Waya",
          key: "about_cms",
          url: slugs.cms_about,
          icon: React.createElement(PictureOutlined),
        },
      ]
    },
    {
      title: "SYSTEM",
      key: "system_group",
      type: 'group',
      children: [
        {
          title: "CTA Configuration",
          key: "cta_sections_cms",
          url: slugs.cms_cta_sections,
          icon: React.createElement(RocketOutlined),
        },
        {
          title: "Global Settings",
          key: "global_settings",
          icon: React.createElement(SettingOutlined),
          url: slugs.cms_settings,
        },
        {
          title: "Admin Access",
          key: "admin_cms",
          icon: React.createElement(SettingOutlined), // Using Setting icon or maybe a lock icon if available
          url: slugs.cms_admins,
        }
      ]
    }
  ];
}
